import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHouse, faMailBulk, faPhone } from "@fortawesome/free-solid-svg-icons"
import { useNavigate, useLocation, useParams } from 'react-router-dom'
import useAuth from "../hooks/useAuth"

const DashFooter = () => {

    const { username, status, name } = useAuth()
    const {groupId, type} = useParams()
    const navigate = useNavigate()
    const { pathname } = useLocation()
    
    const onGoHomeClicked = () => navigate(`/${type}/${groupId}`)

    let goHomeButton = null
    if (pathname !== '/dash') {
        goHomeButton = (
            <button
                className="dash-footer__button icon-button"
                title="Home"
                onClick={onGoHomeClicked}
            >
                <FontAwesomeIcon icon={faHouse} />
            </button>
        )
    }

    const content = (
        <footer className="dash-footer">
            {goHomeButton}
            <p>{username}-{name}</p>
            <p>Status: {status}</p>
            <p>נתקלתם בבעיה?   <a href="tel:+972548479226"> <FontAwesomeIcon icon={faPhone} /></a>  <a href="mailto:geshtop@gmail.com">  <FontAwesomeIcon icon={faMailBulk} /></a> </p>
          
        </footer>
    )
    return content
}
export default DashFooter